import { render, staticRenderFns } from "./identification.vue?vue&type=template&id=2bc382ba&scoped=true&"
import script from "./identification.vue?vue&type=script&lang=js&"
export * from "./identification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc382ba",
  null
  
)

export default component.exports